import { adapterPlanogramItemToPlanogramItemCommon } from "@CommonAdapters/pog";
import {
  PlanogramItem,
  PlanogramItemNonCircular,
  PlanogramItemOrientation,
} from "@CommonTypes/merchflow/pog/item";

export const projectOrientationForSideView = (
  orientation: PlanogramItemOrientation,
): PlanogramItemOrientation => {
  switch (orientation) {
    case "FRONT":
      return "FRONT";
    case "FRONT2":
      return "TOP";
    case "SIDE":
      return "SIDE";
    case "SIDE2":
      return "TOP2";
    case "TOP":
      return "FRONT2";
    case "TOP2":
      return "SIDE2";
  }
};

export const projectPlanogramItemForSideView = (
  item: PlanogramItem,
  shelfUniqueId: string,
): PlanogramItemNonCircular => {
  const projectedItem = adapterPlanogramItemToPlanogramItemCommon(item);

  return {
    ...projectedItem,
    orientation: projectOrientationForSideView(item.orientation),
    validOrientations: item.validOrientations.map(projectOrientationForSideView),
    caseWidth: item.caseDepth,
    caseDepth: item.caseWidth,
    trayWidth: item.trayDepth,
    trayDepth: item.trayWidth,
    unitsTrayWide: item.unitsTrayDeep,
    unitsTrayDeep: item.unitsTrayWide,
    unitWidth: item.unitDepth,
    unitDepth: item.unitWidth,
    unitsCaseWide: item.unitsCaseDeep,
    unitsCaseDeep: item.unitsCaseWide,
    displayWidth: item.displayDepth,
    displayDepth: item.displayWidth,
    squeezeWidth: item.squeezeDepth,
    squeezeDepth: item.squeezeWidth,
    squeezeWidthPct: item.squeezeDepthPct,
    squeezeDepthPct: item.squeezeWidthPct,
    xCapOrientation: projectOrientationForSideView(item.xCapOrientation),
    yCapOrientation: projectOrientationForSideView(item.yCapOrientation),
    zCapOrientation: projectOrientationForSideView(item.zCapOrientation),
    shelf: shelfUniqueId,
    facings: item.facingsRows * item.getDepthFacings(),
  };
};
